import { useAuth } from 'context/authentication/useAuth'
import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

export default function ProtectedRoute(props: { children: ReactNode }) {
  const { isAuthenticated } = useAuth()

  if (!isAuthenticated) {
    return <Navigate to={'/login'} />
  }

  return props.children
}
